module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis7-0ecb9ddee5202992a1d300b5be51c3e1.jpg";